import "./style.css";
import { loadAssets } from "./assets/loader";
import { Game } from "./game/Game";
import { applyTelegramMode } from "./telegram";
import { Screens } from "./ui/screens";

async function boot(): Promise<void> {
  applyTelegramMode();

  const splash = document.getElementById("splash");
  const splashStart = Date.now();
  const SPLASH_MIN_MS = 2000;

  const screens = new Screens();
  screens.show("loading");

  try {
    const assets = await loadAssets((r) => {
      screens.setLoadProgress(r);
    });

    // Keep splash visible for at least SPLASH_MIN_MS
    const elapsed = Date.now() - splashStart;
    if (elapsed < SPLASH_MIN_MS) {
      await new Promise((r) => setTimeout(r, SPLASH_MIN_MS - elapsed));
    }

    // Fade out splash
    if (splash) {
      splash.style.opacity = "0";
      setTimeout(() => splash.remove(), 800);
    }

    const canvas = document.getElementById("game");
    if (!(canvas instanceof HTMLCanvasElement)) {
      throw new Error("Missing #game canvas");
    }
    const game = new Game(canvas, assets);
    game.start();
  } catch (err) {
    if (splash) {
      splash.style.opacity = "0";
      setTimeout(() => splash.remove(), 800);
    }
    const tag = document.querySelector("#screen-loading .tagline");
    if (tag) {
      tag.textContent =
        err instanceof Error ? err.message : "Failed to load Exo Runner.";
    }
    console.error(err);
  }
}

void boot();
